// utils/healthChecks.ts
import { notifications } from "@mantine/notifications";
import coreApi from "../utils/api/coreApi";

export const toggleEnableHealthCheck = async (id: number) => {
  const res = await coreApi.healthChecksToggleEnabled(id);
  const healthCheck = res.data;

  notifications.show({
    title: `${!healthCheck.enabled ? "⏸️ Paused" : "▶️ Resumed"} Health Check`,
    message: `${
      !healthCheck.enabled ? "Paused" : "Resumed"
    }: ${getPrettyCheckName(healthCheck.app.name, healthCheck.name)}`,
    color: !healthCheck.enabled ? "yellow" : "green",
  });

  return healthCheck;
};

export const toggleSubscribeHealthCheck = async (id: number | string) => {
  const res = await coreApi.healthChecksToggleSubscribe(id);
  const healthCheck = res.data;

  notifications.show({
    title: `${
      healthCheck.subscribed ? "🔔 Subscribed to" : " 🔕 Unsubscribed from"
    } Health Check`,
    message: `${
      healthCheck.subscribed ? "Subscribed to" : "Unsubscribed from"
    }: ${getPrettyCheckName(healthCheck.app.name, healthCheck.name)}`,
    color: healthCheck.subscribed ? "green" : "yellow",
  });

  return healthCheck;
};

export const runHealthCheck = async (id: number) => {
  const res = await coreApi.healthChecksManualTrigger(id);
  const healthCheck = res.data;

  notifications.show({
    title: "⏳ Health Check Started",
    message: `Started ${getPrettyCheckName(
      healthCheck.app.name,
      healthCheck.name
    )}`,
    color: "green",
  });

  return healthCheck;
};

export const setAutoPassHealthCheck = async (
  id: number,
  hours: number | null
) => {
  const res = await coreApi.healthChecksSetAutoPass(id, { hours });
  const healthCheck = res.data;

  notifications.show({
    title: hours === null ? "Auto-pass removed" : "Auto-pass enabled",
    message:
      hours === null
        ? `Removed auto-pass: ${getPrettyCheckName(
            healthCheck.app.name,
            healthCheck.name
          )}`
        : `Auto-pass for ${hours}h: ${getPrettyCheckName(
            healthCheck.app.name,
            healthCheck.name
          )}`,
    color: hours === null ? "yellow" : "green",
  });

  return healthCheck;
};

export function getPrettyCheckName(app: string, name: string) {
  return `${app.replace(/_/g, " ")} - ${name.replace(/_/g, " ")}`;
}
